const getters = {
	getMainMenu(state) {
		return state.mainMenu;
	},

	getTheme(state) {
		return state.theme;
	},

	getFooterLinks(state) {
		return state.footerLinks;
	},
};

export { getters as default };
